import CrudCustom from '../../../libs/custom/CrudCustom';

let SubSektorService = new CrudCustom('/sub-sektors');
export default SubSektorService;
